import { FormControl, MenuItem, Select } from "@mui/material";
import { Job } from "generated/graphql";
import useUpdateJobProjectManager from "hooks/jobs/useUpdateJobProjectManager";
import useGetOrganizationUsers from "hooks/users/useGetOrganizationUsers";
import { SxProps, Theme } from "@mui/material/styles";

export default function ProjectManagerSelection({
  projectManager,
  jobId,
  sx,
}: {
  projectManager: Job["userId"];
  jobId: Job["id"];
  sx?: SxProps<Theme>;
}) {
  const { data } = useGetOrganizationUsers({ page: 1, first: 1000 });
  const [updateJobProjectManager, { loading, isSuccess, getData }] = useUpdateJobProjectManager();

  const usersSelectData = data?.map(({ name, firstName, lastName, id }) => ({
    label: name || `${firstName ?? ""} ${lastName ?? ""}`.trim(),
    value: id,
  }));

  const handleSubmit = (userId: Job["userId"]) => {
    updateJobProjectManager({ variables: { id: jobId, userId } });
  };

  return (
    <FormControl
      variant="filled"
      sx={{
        minWidth: 240,
        ...sx,
      }}
    >
      <Select
        labelId="job-project-manager-label"
        id="job-project-manager"
        value={projectManager}
        variant="standard"
        label=""
        disabled={loading}
        onChange={(e) => {
          handleSubmit(e.target.value);
        }}
        sx={{
          "& .MuiSelect-select": {
            py: 0.25,
            pr: 3,
            textAlign: "left",
          },
        }}
      >
        {usersSelectData?.map(({ label, value }) => (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
